module.exports = __webpack_public_path__ + "static/media/mira_search_thumb.2ef135c3.png";